"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spell_anim = exports.spell_cursor = exports.getSpellData = void 0;
var spritesCursors_1 = require("@dive/spriteRecyclers/spritesCursors");
var spritesSpells_1 = require("@dive/spriteRecyclers/spritesSpells");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var diveTilemapUtils_sidecar_1 = require("@dive/tilemap/diveTilemapUtils-sidecar");
var distanceUtil_sidecar_1 = require("@lib/distanceUtil-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageMessageCrewHurt_1 = require("@voyage/multi/voyageMessageCrewHurt");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var key = 'fireball';
// export const getSpellStats = () => {
//   return rogueSpellData.getSpellStats(key)
// }
function getSpellData() {
    return {
        key: key,
        name: 'Fireball',
        desc: 'Hurl a large ball of fire, not recommended',
        castType: 'target',
        targetFinder: 'furthest',
        // targetCursor: rogueSpellFireball.rogueCursorFireball,
        //   targetFinder: 'self',
        //   selfCast: null,
        //   castType: 'target',
        //   hotkey: 'x',
        //   isBought: false,
        //   cost: 2,
        //   maxUses: 4,
        //   usesLeft: 0,
        //   baseDamage: 1,
        //   baseRange: 7,
        //   baseRadius: 2,
        //   duration: 0,
        //   upgrades: [
        //     {
        //       key: 'radius',
        //       name: '',
        //       effectAmount: 0.5,
        //       cost: 2,
        //       isBought: false,
        //     },
        //     {
        //       key: 'radius',
        //       name: '',
        //       effectAmount: 0.5,
        //       cost: 2,
        //       isBought: false,
        //     },
        //     {
        //       key: 'radius',
        //       name: '',
        //       effectAmount: 0.5,
        //       cost: 3,
        //       isBought: false,
        //     },
        //   ],
        // }
    };
}
exports.getSpellData = getSpellData;
// export const getSpellStats = () => {
//   return rogueSpellData.getSpellStats(key)
// }
// export function getSpellData(): IRogueSpellData {
//   return {}
// }
var quadrantMultipliers = [
    [1, 0],
    [1, -1],
    [0, -1],
    [-1, -1],
    [-1, 0],
    [-1, 1],
    [0, 1],
    [1, 1],
];
var spell_cursor = function (options) {
    // TODO: pass this off to the spell's cursor function
    var width = 4 * 2;
    var halfWidth = Math.floor(width / 2);
    var img = spritesCursors_1.spritesCursors.getNext(options.cursorTileX, options.cursorTileY, sprites_sidecar_1.sprites.diveEffectsCursorSpellTarget[0]);
    var minDistance = 1;
    var maxDistance = 7;
    var selectedCrew = voyagePicker_sidecar_1.voyagePicker.get().selectedCrew;
    if (selectedCrew) {
        var distance = distanceUtil_sidecar_1.distanceUtil.distanceNormal(selectedCrew.i, selectedCrew.j, options.cursorI, options.cursorJ);
        if (distance < minDistance || distance > maxDistance) {
            return false;
        }
        // Can we see here?
        var gs = diveTilemap_sidecar_1.diveTilemap.getSafe(options.cursorI, options.cursorJ);
        if (!gs) {
            return false;
        }
        if (!diveTilemapUtils_sidecar_1.diveTilemapUtils.isSpotVisibleToHero(gs)) {
            return false;
        }
        var quadrant = distanceUtil_sidecar_1.distanceUtil.getQuadrant(selectedCrew.i, selectedCrew.j, options.cursorI, options.cursorJ);
        var _a = __read(quadrantMultipliers[quadrant], 2), ym = _a[0], xm = _a[1];
        // console.log('quadrant', quadrant)
        for (var i = -halfWidth; i <= halfWidth; i++) {
            var imgFire = spritesCursors_1.spritesCursors.getNext(options.cursorTileX + i * diveTilemap_sidecar_1.diveTilemap.spotSize * xm, options.cursorTileY + i * diveTilemap_sidecar_1.diveTilemap.spotSize * ym, sprites_sidecar_1.sprites.diveEffectsFire[0]);
            imgFire.alpha = 0.5;
        }
        return true;
    }
    return false;
    //  console.log('img', img)
    // let map = rogueMaps.getCurrentMap()
    // let p = rogueMonsters.getPlayer()
    // if (p) {
    //   if (rogueDef.isSameSpot(p.x, p.y, gridX, gridY)) {
    //     return // No self-cast
    //   }
    //   let tx = p.y
    //   let ty = p.x
    //   let ss = rogueSpellData.getSpellStats(key)
    //   lineAlgo.drawLineBresenham(p.x, p.y, gridX, gridY, (x, y, count) => {
    //     let t = rogueMaps.getTile(map, x, y)
    //     if (!t) {
    //       return false
    //     }
    //     if (count > 0) {
    //       rogueGlyphs.write(x, y, '*', rogueColors.orange)
    //       tx = x
    //       ty = y
    //     }
    //     if (!rogueMaps.isPassibleT(t)) {
    //       return false
    //     }
    //     if (count >= ss.range) {
    //       return false
    //     }
    //     return true
    //   })
    //   let spiral = rogueSpellUtils.spirals[ss.radius]
    //   spiral.forEach((c) => {
    //     rogueGlyphs.write(tx + c.x, ty + c.y, 'target', rogueColors.light)
    //   })
    //   // for (let i = -size; i <= size; i++) {
    //   //   for (let j = -size; j <= size; j++) {
    //   //     rogueGlyphs.write(tx + i, ty + j, 'target', rogueColors.light)
    //   //   }
    //   // }
    // if (activate) {
    //   // TODO: move this to cursor?
    //   // rogueAanimManager.addAnim(rogueAnimFireball(p.x, p.y, tx, ty))
    //   return true
    // }
    // }
};
exports.spell_cursor = spell_cursor;
function spell_anim(o) {
    var tickTime, width, halfWidth, time, delay, segmentTime, segmentDelayAmount, damage, quadrant, _a, ym, xm, isFlipped, i, segmentDelay, loc, gs, _b, x, y, canSee, img, crewHere;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                tickTime = 0.11;
                width = 4 * 2;
                halfWidth = Math.floor(width / 2);
                time = 0;
                delay = 2;
                segmentTime = 20;
                segmentDelayAmount = 1;
                damage = 10;
                quadrant = distanceUtil_sidecar_1.distanceUtil.getQuadrant(o.fromI, o.fromJ, o.startI, o.startJ);
                _a = __read(quadrantMultipliers[quadrant], 2), ym = _a[0], xm = _a[1];
                _c.label = 1;
            case 1:
                if (!(time < segmentTime + segmentDelayAmount * halfWidth)) return [3 /*break*/, 3];
                time++;
                isFlipped = time % 2 === 0;
                for (i = -halfWidth; i <= halfWidth; i++) {
                    segmentDelay = Math.abs(i) * segmentDelayAmount;
                    if (time > segmentDelay && time < segmentTime + segmentDelay) {
                        loc = { i: o.startI + i * xm, j: o.startJ + i * ym };
                        gs = diveTilemap_sidecar_1.diveTilemap.getSafe(loc.i, loc.j);
                        if (!gs) {
                            continue;
                        }
                        if (!gs.tile1.canWalk) {
                            continue;
                        }
                        _b = diveTilemap_sidecar_1.diveTilemap.convertIJtoXY(loc.i, loc.j), x = _b.x, y = _b.y;
                        canSee = diveTilemapUtils_sidecar_1.diveTilemapUtils.isSpotVisibleToHero(gs);
                        if (canSee) {
                            img = spritesSpells_1.spritesSpells.getNext(x, y, sprites_sidecar_1.sprites.diveEffectsFire[0], tickTime * delay);
                            img.scaleX = isFlipped ? -img.scaleX : img.scaleX;
                        }
                        crewHere = diveCrew_sidecar_1.diveCrew.getAtIJ(o.startI + i, o.startJ);
                        if (crewHere) {
                            if (crewHere.type === diveCrew_1.EVoyageCrewType.Enemy) {
                                // TODO: damage effects?
                                diveCrew_sidecar_1.diveCrew.hurt(crewHere, damage, voyageMessageCrewHurt_1.EVoyageCrewDamageType.Fire, 0);
                            }
                        }
                    }
                }
                return [4 /*yield*/, { delay: delay }];
            case 2:
                _c.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
exports.spell_anim = spell_anim;
